export const tagTheme = {
  defaultProps: {
    size: 'lg',
    colorScheme: 'blue',
  },
}
